import {displayMessage} from './utility/message';
import {MessageType} from './utility/messageTypes'; // Adjust the path according to your folder structure
import {apiRequest} from './utility/apiRequest'; // Assuming you have an apiRequest utility

// Interface for the expected structure of the AJAX response
interface AjaxResponse {
    order_status?: string;
    order_action?: string;
    redirect_url?: string;
    message: string | { [key: string]: string[] }; // message can be either a string or an object
}

// Function to initialize checkout form submission handling
function initCheckoutFormHandler(): void {
    const checkoutForm = document.querySelector('.ambikly-checkout-form') as HTMLFormElement;
    if (!checkoutForm) return;

    checkoutForm.addEventListener('submit', handleSubmit);
    const billingCountry = checkoutForm.querySelector('[name="billing_country"]') as HTMLInputElement;
    billingCountry.addEventListener('change', handleCountryChange);
    //initLib();
}

function handleCountryChange(e: Event) {
    // Ignoring type errors for Select2
    // @ts-ignore
    const country = e.target.value;
    // @ts-ignore
    const states = ambikly.states[country] ?? {}

    if (Object.keys(states).length < 1 || !states) {

        return;
    }

    const checkoutForm = document.querySelector('.ambikly-checkout-form') as HTMLFormElement;

    if (!checkoutForm) return;


    const billingStateGroup = checkoutForm.querySelector('.ambikly-field-billing_state');

    if (!billingStateGroup) return;

    const billingStateInput = billingStateGroup.querySelector('#billing_state');
    if (billingStateInput) {
        billingStateInput.remove();
    }
    const selectElement = document.createElement('select');
    selectElement.name = 'billing_state';
    selectElement.id = 'billing_state';
    selectElement.required = true; // Keep the "required" attribute

    // Add a placeholder option
    const placeholderOption = document.createElement('option');
    placeholderOption.value = '';
    placeholderOption.textContent = '-- Select State --';
    placeholderOption.disabled = true;
    placeholderOption.selected = true;
    selectElement.appendChild(placeholderOption);

    // Populate the select element with states
    for (const [stateCode, stateName] of Object.entries(states)) {
        const option = document.createElement('option');
        option.value = stateCode;
        // @ts-ignore
        option.textContent = stateName;
        selectElement.appendChild(option);
    }

    // Append the select element to the form group
    billingStateGroup.appendChild(selectElement);
}

// Form submit handler
async function handleSubmit(e: Event): Promise<void> {
    e.preventDefault();
    const checkoutForm = e.target as HTMLFormElement;
    const formData = new FormData(checkoutForm);

    try {
        const jsonResponse = await submitCheckoutForm(formData);
        handleResponse(jsonResponse, checkoutForm);
    } catch (error) {
        console.error('Error during form submission:', error);
        displayMessage(checkoutForm, 'An error occurred while submitting the form.', MessageType.ERROR, true, true);
    }
}

// Function to submit the checkout form via an API request
async function submitCheckoutForm(formData: FormData): Promise<AjaxResponse> {
    const response = await apiRequest((window as any).ambikly.ajax_url, {
        method: 'POST',
        body: formData,
    });
    return JSON.parse(response) as AjaxResponse;
}

// Function to handle the server response after form submission
function handleResponse(jsonResponse: AjaxResponse, checkoutForm: HTMLFormElement): void {
    if (jsonResponse.order_status === 'success') {
        handleSuccessResponse(jsonResponse, checkoutForm);
    } else if (jsonResponse.order_status === 'failed' && jsonResponse.message) {
        const errorMessages = buildMessage(jsonResponse.message);
        displayMessage(checkoutForm, errorMessages, MessageType.ERROR, true, true);
    } else {
        displayMessage(checkoutForm, 'Order failed or was canceled.', MessageType.ERROR, true, true);
    }
}

// Function to handle successful order responses
function handleSuccessResponse(jsonResponse: AjaxResponse, checkoutForm: HTMLFormElement): void {
    const message = buildMessage(jsonResponse.message);
    displayMessage(checkoutForm, message, MessageType.SUCCESS);

    if (jsonResponse.order_action === 'redirect' && jsonResponse.redirect_url) {
        setTimeout(() => {
            window.location.href = jsonResponse.redirect_url!;
        }, 2000); // Redirect after 2 seconds
    }
}

// Function to build an HTML string containing a list of error messages
function buildMessage(messages: string | string[] | { [key: string]: string[] }): string {
    // If messages is a string, return it directly
    if (typeof messages === 'string') {
        return messages; // Return the message directly
    }

    let messageListHTML = '<ul>';

    // If messages is an array of strings, iterate through it
    if (Array.isArray(messages)) {
        messages.forEach(message => {
            messageListHTML += `<li>${message}</li>`; // Add each message as a list item
        });
    }
    // If messages is an object, iterate over its fields
    else if (typeof messages === 'object') {
        for (const field in messages) {
            if (messages.hasOwnProperty(field)) {
                messages[field].forEach(message => {
                    messageListHTML += `<li>${message}</li>`; // Add each message as a list item
                });
            }
        }
    }

    messageListHTML += '</ul>';
    return messageListHTML;
}

// Wait for DOM content to be loaded and initialize the form handler
document.addEventListener('DOMContentLoaded', initCheckoutFormHandler);
